
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/base/index.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"基础用法","toc":"menu","filename":"pages/pages/reference/base/index.md","lastUpdated":1773900960000,"description":"这是一个带有表单元素的简单动态表格"};